import { render, staticRenderFns } from "./TopBarTitle.vue?vue&type=template&id=bf7aaea0&scoped=true"
import script from "./TopBarTitle.vue?vue&type=script&lang=js"
export * from "./TopBarTitle.vue?vue&type=script&lang=js"
import style0 from "./TopBarTitle.vue?vue&type=style&index=0&id=bf7aaea0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf7aaea0",
  null
  
)

export default component.exports